module.exports = __webpack_public_path__ + "img/cat.be5030ca.webp";